import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#dddddd",
    },
  },
  typography: { fontFamily: "liberation serif", fontSize: 14 },
});
